export default "__VITE_ASSET__D0mUrj34__"